var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.33858 16.1902V5.48173H0.125984V16.1902H3.33858ZM3.33858 1.65727C3.33858 0.701152 2.70866 0 1.6378 0C0.692913 0 0 0.701152 0 1.65727C0 2.61338 0.629921 3.31453 1.6378 3.31453C2.70866 3.37828 3.33858 2.61338 3.33858 1.65727ZM8.69291 16.1902V10.0711C8.69291 9.75238 8.69291 9.43368 8.8189 9.17871C9.07087 8.5413 9.6378 7.84015 10.6457 7.84015C11.9685 7.84015 12.7244 8.60504 12.7244 10.0711V16.1902H16V9.94361C16 6.56533 14.2362 5.03554 11.9055 5.03554C9.95276 5.03554 9.13386 6.11914 8.62992 6.88403V5.48173H5.41732C5.48032 6.50159 5.41732 16.254 5.41732 16.254H8.69291V16.1902Z","fill":"white"}));
}

LinkedinIcon.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
